@file:OptIn(InternalResourceApi::class)

package ischoolconnect.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ischoolconnect.sharedui.generated.resources/"

@delegate:ResourceContentHash(-1_987_786_695)
internal val Res.drawable.role_parent: DrawableResource by lazy {
      DrawableResource("drawable:role_parent", setOf(
        ResourceItem(setOf(), "${MD}drawable/role_parent.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-790_498_762)
internal val Res.drawable.role_school_admin: DrawableResource by lazy {
      DrawableResource("drawable:role_school_admin", setOf(
        ResourceItem(setOf(), "${MD}drawable/role_school_admin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-539_018_918)
internal val Res.drawable.role_superadmin: DrawableResource by lazy {
      DrawableResource("drawable:role_superadmin", setOf(
        ResourceItem(setOf(), "${MD}drawable/role_superadmin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_358_561_717)
internal val Res.drawable.role_teacher: DrawableResource by lazy {
      DrawableResource("drawable:role_teacher", setOf(
        ResourceItem(setOf(), "${MD}drawable/role_teacher.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_726_972_151)
internal val Res.drawable.school_config: DrawableResource by lazy {
      DrawableResource("drawable:school_config", setOf(
        ResourceItem(setOf(), "${MD}drawable/school_config.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_713_658_246)
internal val Res.drawable.school_users: DrawableResource by lazy {
      DrawableResource("drawable:school_users", setOf(
        ResourceItem(setOf(), "${MD}drawable/school_users.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-241_556_642)
internal val Res.drawable.schools: DrawableResource by lazy {
      DrawableResource("drawable:schools", setOf(
        ResourceItem(setOf(), "${MD}drawable/schools.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_456_790_758)
internal val Res.drawable.search: DrawableResource by lazy {
      DrawableResource("drawable:search", setOf(
        ResourceItem(setOf(), "${MD}drawable/search.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_278_463_967)
internal val Res.drawable.shield: DrawableResource by lazy {
      DrawableResource("drawable:shield", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_418_498_955)
internal val Res.drawable.sort: DrawableResource by lazy {
      DrawableResource("drawable:sort", setOf(
        ResourceItem(setOf(), "${MD}drawable/sort.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_520_996_478)
internal val Res.drawable.stat_helpdesk: DrawableResource by lazy {
      DrawableResource("drawable:stat_helpdesk", setOf(
        ResourceItem(setOf(), "${MD}drawable/stat_helpdesk.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_725_372_315)
internal val Res.drawable.stat_parents: DrawableResource by lazy {
      DrawableResource("drawable:stat_parents", setOf(
        ResourceItem(setOf(), "${MD}drawable/stat_parents.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_379_949_940)
internal val Res.drawable.stat_school: DrawableResource by lazy {
      DrawableResource("drawable:stat_school", setOf(
        ResourceItem(setOf(), "${MD}drawable/stat_school.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_426_252_447)
internal val Res.drawable.stat_students: DrawableResource by lazy {
      DrawableResource("drawable:stat_students", setOf(
        ResourceItem(setOf(), "${MD}drawable/stat_students.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_946_679_549)
internal val Res.drawable.stat_teacher: DrawableResource by lazy {
      DrawableResource("drawable:stat_teacher", setOf(
        ResourceItem(setOf(), "${MD}drawable/stat_teacher.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(48_065_990)
internal val Res.drawable.stat_users: DrawableResource by lazy {
      DrawableResource("drawable:stat_users", setOf(
        ResourceItem(setOf(), "${MD}drawable/stat_users.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_283_621_062)
internal val Res.drawable.subscriptions: DrawableResource by lazy {
      DrawableResource("drawable:subscriptions", setOf(
        ResourceItem(setOf(), "${MD}drawable/subscriptions.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_741_206_068)
internal val Res.drawable.teacher: DrawableResource by lazy {
      DrawableResource("drawable:teacher", setOf(
        ResourceItem(setOf(), "${MD}drawable/teacher.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_987_956_028)
internal val Res.drawable.trash: DrawableResource by lazy {
      DrawableResource("drawable:trash", setOf(
        ResourceItem(setOf(), "${MD}drawable/trash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_648_493_126)
internal val Res.drawable.trust_footer_bar: DrawableResource by lazy {
      DrawableResource("drawable:trust_footer_bar", setOf(
        ResourceItem(setOf(), "${MD}drawable/trust_footer_bar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(84_745_631)
internal val Res.drawable.user: DrawableResource by lazy {
      DrawableResource("drawable:user", setOf(
        ResourceItem(setOf(), "${MD}drawable/user.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_055_241_058)
internal val Res.drawable.user_avatar: DrawableResource by lazy {
      DrawableResource("drawable:user_avatar", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_avatar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_785_868_827)
internal val Res.drawable.user_cog: DrawableResource by lazy {
      DrawableResource("drawable:user_cog", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_cog.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-286_991_450)
internal val Res.drawable.user_plus: DrawableResource by lazy {
      DrawableResource("drawable:user_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_259_651_090)
internal val Res.drawable.users: DrawableResource by lazy {
      DrawableResource("drawable:users", setOf(
        ResourceItem(setOf(), "${MD}drawable/users.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable1Resources(map: MutableMap<String, DrawableResource>) {
  map.put("role_parent", Res.drawable.role_parent)
  map.put("role_school_admin", Res.drawable.role_school_admin)
  map.put("role_superadmin", Res.drawable.role_superadmin)
  map.put("role_teacher", Res.drawable.role_teacher)
  map.put("school_config", Res.drawable.school_config)
  map.put("school_users", Res.drawable.school_users)
  map.put("schools", Res.drawable.schools)
  map.put("search", Res.drawable.search)
  map.put("shield", Res.drawable.shield)
  map.put("sort", Res.drawable.sort)
  map.put("stat_helpdesk", Res.drawable.stat_helpdesk)
  map.put("stat_parents", Res.drawable.stat_parents)
  map.put("stat_school", Res.drawable.stat_school)
  map.put("stat_students", Res.drawable.stat_students)
  map.put("stat_teacher", Res.drawable.stat_teacher)
  map.put("stat_users", Res.drawable.stat_users)
  map.put("subscriptions", Res.drawable.subscriptions)
  map.put("teacher", Res.drawable.teacher)
  map.put("trash", Res.drawable.trash)
  map.put("trust_footer_bar", Res.drawable.trust_footer_bar)
  map.put("user", Res.drawable.user)
  map.put("user_avatar", Res.drawable.user_avatar)
  map.put("user_cog", Res.drawable.user_cog)
  map.put("user_plus", Res.drawable.user_plus)
  map.put("users", Res.drawable.users)
}
